import { render, staticRenderFns } from "./LandingForPlanners.vue?vue&type=template&id=dea46c40&scoped=true"
import script from "./LandingForPlanners.vue?vue&type=script&lang=js"
export * from "./LandingForPlanners.vue?vue&type=script&lang=js"
import style0 from "./LandingForPlanners.vue?vue&type=style&index=0&id=dea46c40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea46c40",
  null
  
)

export default component.exports